export const Constants = {
  downloadText:
    'Você pode realizar o download dos seguintes documentos anexados:',
  propertyRegister: 'Matrícula do imóvel',
  download: 'download',
  iptu: 'Cartela do IPTU',
  registerNumber: 'nº da matrícula:',
  registryOffice: 'código do cartório (cns):',
  book: 'livro de registro',
  propertyType: 'tipo do imóvel:',
  concept: 'conceito do espaço:',
  zone: 'ofício/zona:',
  judicialDistrict: 'comarca:',
  registrationUf: 'UF:',
};
